import { render, staticRenderFns } from "./SidebarNavTitleIS.vue?vue&type=template&id=7052f836"
import script from "./SidebarNavTitleIS.vue?vue&type=script&lang=js"
export * from "./SidebarNavTitleIS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports